/**
 * Uygulama mi tarayici mi? Indirme alanini GIZLEMEK icin.
 *
 * Masaustu (Electron) ve mobil (Capacitor) istemcileri AYNI web uygulamasini
 * yukluyor; farki yalnizca enjekte ettikleri isaretlerden anliyoruz:
 *   - Electron: `preload.js` `window.hedefDesktop`i aciyor; ayrica UA'ya
 *     `HedefAIDesktop/<surum>` ekleniyor (`desktop/src/main.js`).
 *   - Capacitor: yerel platformda `window.Capacitor.isNativePlatform()` true.
 *
 * "Uygulamayi indir" alani yalnizca TARAYICIDA anlamli - zaten uygulamadan
 * giren biri uygulamayi kurmus demektir. Bu yuzden native ise gizliyoruz.
 */

interface CapacitorGlobal {
  isNativePlatform?: () => boolean
}

// `hedefDesktop` zaten `lib/toolRunner.ts` icinde global olarak tanimli;
// burada yalnizca Capacitor'u ekliyoruz (Window arayuzu dosyalar arasi
// birlesiyor).
declare global {
  interface Window {
    Capacitor?: CapacitorGlobal
  }
}

export function isDesktopApp(): boolean {
  if (typeof window === 'undefined') return false
  if (window.hedefDesktop) return true
  return /HedefAIDesktop/i.test(navigator.userAgent || '')
}

export function isMobileApp(): boolean {
  if (typeof window === 'undefined') return false
  const cap = window.Capacitor
  try {
    return Boolean(cap?.isNativePlatform?.())
  } catch {
    return false
  }
}

/** Herhangi bir yerel uygulama (masaustu veya mobil) icinde miyiz? */
export function isNativeApp(): boolean {
  return isDesktopApp() || isMobileApp()
}

/** Tarayicida miyiz? (indirme alani yalnizca burada gosterilir) */
export function isBrowser(): boolean {
  return !isNativeApp()
}

export type OS = 'windows' | 'macos' | 'android' | 'ios' | 'linux' | 'unknown'

/**
 * Ziyaretcinin isletim sistemi - "bu sisteme uygun" indirmeyi ONE CIKARMAK
 * icin. Kurulum dosyamiz olan uc platform (windows/macos/android) oncelikli;
 * ios/linux "indirme yok" durumuna dusuyor (ios icin App Store/TestFlight
 * ileride).
 *
 * iPadOS Safari kendini "Mac" gibi tanitir; dokunma noktalariyla ayirt
 * ediliyor (parmakla kullanilan bir Mac yok).
 */
export function currentOS(): OS {
  if (typeof navigator === 'undefined') return 'unknown'
  const ua = navigator.userAgent || ''
  const touch = (navigator.maxTouchPoints || 0) > 1
  if (/Android/i.test(ua)) return 'android'
  if (/iPhone|iPod/i.test(ua)) return 'ios'
  if (/iPad/i.test(ua)) return 'ios'
  if (/Windows/i.test(ua)) return 'windows'
  if (/Macintosh|Mac OS X/i.test(ua)) return touch ? 'ios' : 'macos'
  if (/Linux/i.test(ua)) return 'linux'
  return 'unknown'
}
